import classNames from 'classnames';
import React, {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  ReactNode,
  FC,
} from 'react';

import { CosmosComponent } from '../../../types';

import styles from './ButtonDeprecated.module.css';

import { SpinnerDeprecated } from '../SpinnerDeprecated';

export type Variant = 'primary' | 'secondary' | 'tertiary' | 'text';

export interface ButtonDeprecatedProps extends CosmosComponent {
  active?: boolean;
  component?: 'button' | 'a';
  label?: string | ReactNode;
  text?: string | ReactNode;
  variant?: Variant;
  rightElement?: JSX.Element;
  disabled?: boolean;
  loading?: boolean;
  autoWidth?: boolean;
  href?: string;
}

type CosmosButton = ButtonDeprecatedProps &
  ButtonHTMLAttributes<object> &
  AnchorHTMLAttributes<object>;

export const ButtonDeprecated: FC<CosmosButton> = ({
  active,
  isInverted,
  isGrey,
  className,
  children,
  component = 'button',
  label,
  text,
  role = 'button',
  variant = 'primary',
  rightElement,
  disabled,
  loading,
  autoWidth,
  testId,
  ...props
}) => {
  if (label) {
    console.warn(
      'cosmos-components/Button - label prop is deprecated and will be removed in the version 0.30, please use "text" prop or pass button text as children',
    );
  }

  const Component = component as any;
  const buttonText = text || label;

  return (
    <Component
      {...props}
      className={classNames(className, styles.Button, styles[variant], {
        [styles.active]: active,
        [styles.inverted]: isInverted,
        [styles.grey]: isGrey,
        [styles.auto]: autoWidth,
      })}
      role={role}
      tabIndex={0}
      disabled={disabled || loading}
      data-test-id={testId}
    >
      {(loading && (
        <SpinnerDeprecated
          size="small"
          variant={variant as Variant}
          isInverted={isInverted}
        />
      )) ||
        children ||
        buttonText}
      {rightElement && <span className={styles.right}>{rightElement}</span>}
    </Component>
  );
};
